module.exports = __webpack_public_path__ + "static/media/plug_img1.de6433a9.svg";